import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

export default class extends Controller {
    static values = {
        labels: Array,
        data: Array,
        label: String
    }

    connect() {
        const config = {
            type: 'radar',
            data: {
                labels: this.labelsValue,
                datasets: [{
                    label: this.labelValue || 'Risk Profile',
                    data: this.dataValue,
                    fill: true,
                    backgroundColor: 'rgba(75, 192, 192, 0.2)', // Primary color with opacity
                    borderColor: 'rgb(75, 192, 192)', // Primary color
                    pointBackgroundColor: 'rgb(75, 192, 192)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgb(75, 192, 192)'
                }]
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: false // Cusotm legend usually looks better
                    },
                    tooltip: {
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        titleColor: '#1f2937',
                        bodyColor: '#1f2937',
                        borderColor: 'rgba(0, 0, 0, 0.1)',
                        borderWidth: 1,
                        padding: 10,
                        displayColors: false,
                        callbacks: {
                            label: function (context) {
                                return context.formattedValue + '%';
                            }
                        }
                    }
                },
                scales: {
                    r: {
                        angleLines: {
                            color: 'rgba(0, 0, 0, 0.05)'
                        },
                        grid: {
                            color: 'rgba(0, 0, 0, 0.05)'
                        },
                        pointLabels: {
                            font: {
                                size: 11,
                                weight: 'bold'
                            },
                            color: 'rgba(31, 41, 55, 0.5)' // base-content/50
                        },
                        ticks: {
                            display: false, // Clean look
                            stepSize: 20
                        },
                        suggestedMin: 0,
                        suggestedMax: 100
                    }
                },
                elements: {
                    line: {
                        borderWidth: 2,
                        tension: 0.3 // Smooth curves
                    }
                }
            }
        };

        // Apply custom styling based on theme if needed (can be expanded)
        // For now, using a neutral/primary teal base as per request context hints

        // Check if we want to use CSS variables for colors later
        const ctx = this.element.querySelector('canvas').getContext('2d');

        // Create gradient
        const gradient = ctx.createLinearGradient(0, 0, 0, 400);
        // Let's try to grab the primary color from computed styles if possible, or fallback
        // Since I can't easily read CSS vars in JS without the element being in DOM and styles loaded,
        // I will use a safe default that matches the 'primary' tailwind look or hardcoded hex for now.
        // Assuming a teal/cyan primary based on previous context.

        // Hardcoded 'primary' approximation for now to ensure it looks good immediately
        const primaryColor = '79, 70, 229'; // Indigo-600 example, or we can use the teal from before.
        // Let's stick to the previous teal-ish look:
        // Actually, let's use a nice Indigo/Primary standard.

        config.data.datasets[0].backgroundColor = 'rgba(79, 70, 229, 0.2)';
        config.data.datasets[0].borderColor = 'rgba(79, 70, 229, 1)';
        config.data.datasets[0].pointBackgroundColor = 'rgba(79, 70, 229, 1)';
        config.data.datasets[0].pointHoverBorderColor = 'rgba(79, 70, 229, 1)';

        this.chart = new Chart(this.element.querySelector('canvas'), config);
    }

    disconnect() {
        if (this.chart) {
            this.chart.destroy();
        }
    }
}
